"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
export default function Footer() {
  const pathname = usePathname();
  return (
    <>
      <footer
        className="p-5 lg:p-20 md:p-10"
        style={{ backgroundImage: "url('/hero_section/navbar_bg.svg')" }}
      >
        <div className="flex items-center space-x-4">
          <Link href="/" className="flex items-center space-x-2">
            <Image
              src="/application_logo/second_line_logo.svg"
              width={40}
              height={40}
              alt="2nd Line Application Logo"
            />
          </Link>
          <span className="text-[24px] font-bold">2nd Line</span>
        </div>

        <div className="mt-5 flex flex-col lg:flex-row md:flex-row w-full">
          <span className="block text-gray-500  md:w-[300px] break-words text-[10px] lg:text-[16px] md:text-[16px] leading-relaxed">
            2nd Line phone number for work, dating, or privacy. Call & text
            without extra SIMs. Stay connected & in control with one easy app!
          </span>
          <div className="w-full flex flex-col lg:flex-row md:flex-row  justify-end gap-2 md:gap-4 lg:gap-20 mt-5 lg:mt-0 md:mt-0">
            <div className="flex  w-full justify-between lg:justify-end md:justify-end gap-0 md:gap-4 lg:gap-24 ">
              <div className="space-y-3 lg:space-y-5 md:space-y-5 flex flex-col">
                <span className="text-[20px]  font-bold">Quick Links</span>
                <Link
                  className={`text-[16px] text-gray-500 cursor-pointer hover:text-[#1CBFA2] ${
                    pathname === "/" ? " text-[#1CBFA2]" : ""
                  }`}
                  href="/"
                  title="Go to homepage"
                >
                  Home
                </Link>
                <Link
                  className={`text-[16px] text-gray-500 cursor-pointer hover:text-[#1CBFA2] ${
                    pathname === "/support" ? " text-[#1CBFA2]" : ""
                  }`}
                  href="/support#faqs"
                  title="Go to FAQs"
                >
                  FAQs
                </Link>

                <Link
                  className={`text-[16px] text-gray-500 cursor-pointer hover:text-[#1CBFA2] ${
                    pathname === "/support" ? " text-[#1CBFA2]" : ""
                  }`}
                  href="/support#contactus"
                  title="Go to Contact Us"
                >
                  Contact Us
                </Link>
              </div>
              <div className="space-y-3 lg:space-y-5 md:space-y-5 flex flex-col">
                <span className="text-[20px] font-bold">Contact Us</span>
                <a
                  href="mailto:support@appyogi.com"
                  title="Send an email to support@appyogi.com"
                  className="text-[16px] text-gray-500 hover:text-[#1CBFA2] cursor-pointer"
                >
                  support@appyogi.com
                </a>
                {/* <a
                  href="tel:+18888072462"
                  title="Call support at (+1) 888 807 2462"
                  className="text-[16px] text-gray-500 hover:text-[#1CBFA2] cursor-pointer"
                >
                  (+1) 888 807 2462
                </a> */}
              </div>
            </div>

            <div className="space-y-3 lg:space-y-5 md:space-y-5 flex flex-col mt-5 lg:mt-0 md:mt-0">
              <span className="text-[20px] font-bold">Get App</span>
              <a
                href="https://apps.apple.com/us/app/second-phone-number-2nd-line/id1607181162"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 px-4 py-1 bg-black border-2 border-black rounded-lg  group hover:bg-[#1CBFA2] hover:border-white hover:text-white cursor-pointer w-[185px]"
              >
                {/* Apple Icon */}
                <div className="flex-shrink-0">
                  <Image
                    src="/appstore_icons/apple_white.svg" // You'll need to add this icon to your public folder
                    alt="Apple"
                    width={30}
                    height={30}
                  />
                </div>

                {/* Text Content */}
                <div className="flex flex-col items-start">
                  <span className="text-xs text-white  font-normal leading-tight">
                    Download on the
                  </span>
                  <span className="text-[23px] text-white  leading-tight">
                    App Store
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="flex w-full justify-between lg:justify-start gap-4 mt-5 lg:mt-0 ">
       <a
  href="#"
  onClick={(e) => e.preventDefault()}
  aria-label="Facebook"
  title="Facebook"
  className="group rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white hover:text-white cursor-pointer"
>
  <Image
    src="/social_media/facebook.svg"
    width={20}
    height={20}
    alt="Facebook"
    className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300"
  />
</a>


          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            title="Instagram"
            aria-label="Instagram"
            className="group rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white hover:text-white cursor-pointer"
          >
            <Image
              src="/social_media/instagram.svg"
              width={20}
              height={20}
              alt="Instagram"
              className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300"

            />
          </a>

          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            title="Twitter"
            aria-label="Twitter"
            className="group rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white hover:text-white cursor-pointer"
          >
            <Image
              src="/social_media/twitter.svg"
              width={20}
              height={20}
              alt="Twitter"
                className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300"

            />
          </a>

          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            title="YouTube"
            aria-label="YouTube"
            className="group rounded-full border border-black p-3 flex items-center transition-all duration-300 hover:bg-[#1CBFA2] hover:border-white hover:text-white cursor-pointer"
          >
            <Image
              src="/social_media/youtube.svg"
              width={20}
              height={20}
              alt="YouTube"
              className="filter group-hover:invert group-hover:brightness-0 group-hover:contrast-200 transition-all duration-300"

            />
          </a>
        </div>
      </footer>
      <hr className="border-t border-gray-300" />
      <div
        className="py-5 lg:py-5 md:py-5 px-5 lg:px-20 md:px-10 w-full"
        style={{ backgroundImage: "url('/hero_section/navbar_bg.svg')" }}
      >
        <div className="flex flex-col lg:flex-row md:flex-row w-full justify-between items-center">
          <span className="text-gray-500 text-sm lg:text-[16px] lg:text-base md:text-base mb-4 lg:mb-0">
            © {new Date().getFullYear()} 2nd Line. All rights reserved.
          </span>
          <div className="flex flex-col lg:flex-row md:flex-row gap-2 lg:gap-6 md:gap-4 justify-center items-center">
            <Link
              href="/legal/terms"
              className={`text-gray-500 text-sm lg:text-[16px] lg:text-base hover:text-[#1CBFA2] md:text-base ${
                pathname === "/legal/terms" ? " text-[#1CBFA2]" : ""
              }`}
              title="Go to terms Pages"
            >
              Terms & Conditions
            </Link>
            <Link
              href="/legal/messaging"
              className={`text-gray-500 text-sm lg:text-base hover:text-[#1CBFA2] ${
                pathname === "/legal/messaging" ? "text-[#1CBFA2]" : ""
              }`}
              title="Go to Messaging Policy Page"
            >
              Messaging Policy
            </Link>
            <Link
              href="/legal/privacy"
              className={`text-gray-500 text-sm lg:text-[16px] hover:text-[#1CBFA2]  lg:text-base md:text-base ${
                pathname === "/legal/privacy" ? " text-[#1CBFA2]" : ""
              }`}
              title="Go to Privacy Policy page"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
